export default __webpack_public_path__ + "static/media/caseSlide3.fcd056f3.png";